import axios from 'axios';

const getFloor = (level) => {
  return axios.get(`${process.env.PUBLIC_URL}/json/floor_${level}.geojson`);
};

const getGeoJSON = () => {
  return axios.get(`${process.env.PUBLIC_URL}/json/all_floors.geojson`)
}

const allFloors = () => {
  return axios.get(`${process.env.PUBLIC_URL}/json/all_floors.json`);
}

export { getFloor, allFloors };
